import { useLocation } from 'react-router-dom';
import { DSIcon, DSTypography } from '@eiv2/design-system';
import { NAV_LINKS } from './navConfig';

export interface MobileNavPillProps {
  onOpenMenu: () => void;
}

export function MobileNavPill({ onOpenMenu }: MobileNavPillProps) {
  const location = useLocation();
  const current =
    NAV_LINKS.find(
      (link) =>
        location.pathname === link.path || location.pathname.startsWith(`${link.path}/`)
    ) ?? NAV_LINKS[0]!;

  return (
    <button
      aria-label={`Menu de navegação — ${current.label}`}
      className="flex h-[72px] w-full cursor-pointer items-center gap-2 rounded-[12px] border border-solid border-gray-3 bg-body-light-mode-1 p-6 text-left transition-colors duration-150 hover:bg-gray-2"
      onClick={onOpenMenu}
      type="button"
    >
      <span className="inline-flex size-6 shrink-0 items-center justify-center text-dark-3">
        <DSIcon name={current.icon} size={24} />
      </span>
      <DSTypography as="span" className="min-w-0 flex-1 truncate text-[14px] font-normal text-dark-3">
        {current.label}
      </DSTypography>
      <DSIcon className="shrink-0 text-dark-3" name="HamburgerMenu" size={20} />
    </button>
  );
}
